import React, {useState, useEffect} from 'react'
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import { updateResult } from './FormsApi'
import {marks} from '../addons'

const toSliderValue = (value) => {
    if (value === null || value === undefined || value === '') {
        return 40
    }
    const numericValue = typeof value === 'number' ? value : parseInt(value, 10)
    if (!Number.isFinite(numericValue)) {
        return 40
    }
    return numericValue
}

const SliderItemComponent = ({value, mark, number, studyId, names, onResultChange}) => {
    const handleChange = async (val) => {
        const sliderValue = Array.isArray(val) ? val[0] : val
        onResultChange?.(mark, number, sliderValue)
        await updateResult(sliderValue, mark, number, studyId)
    }

    const numValue = toSliderValue(value)
    const [currentValue, setCurrentValue] = useState([numValue]);

    useEffect(() => {
        setCurrentValue([toSliderValue(value)]);
    }, [value]);

    const handleSliderChange = (val) => {
        const newValue = Array.isArray(val) ? val[0] : val;
        setCurrentValue([newValue]);
    }

    const handleAfterChange = (val) => {
        const newValue = Array.isArray(val) ? val[0] : val;
        setCurrentValue([newValue]);
        handleChange(newValue);
    }

    return(
    <div style={{width: '100%'}}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%', marginBottom: 5 }}>
        <div style={{color: 'red', width: '50%'}}>{names[1]}</div>
        <div style={{color: 'blue', width: '50%', textAlign: 'right'}}>{names[0]}</div>
    </div>
    <Slider
        range
        className='t-slider'
        value={currentValue}
        pushable={true}
        marks={marks}
        max={80}
        min={0}
        step={5}
        onChange={handleSliderChange}
        onAfterChange={handleAfterChange}
      /></div>)
}

export default SliderItemComponent
